const DEFAULT_PROD_API = "https://hotlead.onrender.com";
const DEFAULT_LOCAL_API = "http://localhost:5001";

const isBrowser =
  typeof window !== "undefined" && typeof window.location !== "undefined";

const isLocalHost = () => {
  if (!isBrowser) {
    return false;
  }

  const hostname = window.location.hostname;
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "::1"
  );
};

export function getApiBaseUrl() {
  const envBase = process.env.REACT_APP_API_URL;

  // Explicit env override takes priority
  if (envBase && typeof envBase === "string" && envBase.trim()) {
    return envBase.trim().replace(/\/$/, "");
  }

  // Local development
  if (isLocalHost()) {
    return DEFAULT_LOCAL_API;
  }

  // Production: Always use Render backend (handles secrets, Neon DB connection)
  return DEFAULT_PROD_API;
}

export function buildApiUrl(path = "") {
  const base = getApiBaseUrl();

  if (!path) {
    return base;
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  if (!base) {
    return normalizedPath;
  }

  return `${base}${normalizedPath}`;
}
